(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sbBffIntegration"), require("sbJsExtends"));
	else if(typeof define === 'function' && define.amd)
		define("sbSportsContentLib", ["sbBffIntegration", "sbJsExtends"], factory);
	else if(typeof exports === 'object')
		exports["sbSportsContentLib"] = factory(require("sbBffIntegration"), require("sbJsExtends"));
	else
		root["sbSportsContentLib"] = factory(root["sbBffIntegration"], root["sbJsExtends"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 